import React from 'react';
import {ListWrapper} from './list/List';

const MultipleIVR: React.FC = () => {
  return (
    <div>
      <ListWrapper />
    </div>
  );
};

export default MultipleIVR;